import theme from "../../theme/theme";
import React from 'react';
import { UsergroupAddOutlined, UserOutlined, FileOutlined, ApartmentOutlined } from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import SidebarFooter from './SidebarFooter';
import { useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { useBasePath } from '../../hooks/useBasePath';
import { ShowMenu } from '../../utils';
import { useAccess } from '../../hooks/usePermission';
const { Sider } = Layout;

const Sidebar = ({ collapsed }) => {
    const navigate = useNavigate();
    const { openKey, selectKey } = useBasePath();
    // Menu items follow the logged-in role's permissions
    const access = useAccess();

    return (
        <Sider
            className='layout_sidebar'
            collapsible
            collapsed={collapsed}
            width={240}
            trigger={!collapsed ? <SidebarFooter /> : null}
        >
            <Logo collapsed={collapsed} />
            <div className='sidebar_menus'>
                <Menu
                    mode="inline"
                    selectedKeys={selectKey}
                    defaultOpenKeys={openKey}
                    className='menu-side'
                    style={{ background: theme.colors.secondary, color: '#fff' }}
                    items={[
                        // {
                        //     key: 'dashboard',
                        //     icon: < DashboardOutlined />,
                        //     label: 'Dashboard Management',
                        //     onClick: () => {
                        //         navigate("/")
                        //     }
                        // },
                        {
                            key: 'hip',
                            icon: <FileOutlined />,
                            label: 'HIP Dashboard',
                            style: { display: ShowMenu(["HIP Dashboard"], access) },
                            onClick: () => {
                                navigate("/hip-dashboard")
                            }
                        },
                        {
                            key: 'HIU Dashboard',
                            icon: <FileOutlined />,
                            label: 'HIU Dashboard',
                            style: { display: ShowMenu(["HIU Dashboard"], access) },
                            onClick: () => {
                                navigate("/hiu-dashboard")
                            }
                        },
                        // {
                        //     key: 'ticket-management',
                        //     icon: <FileOutlined />,
                        //     label: 'Ticket Management',
                        //     style: { display: ShowMenu(["Ticket Management"]) },
                        //     onClick: () => {
                        //         navigate("/ticket-management")
                        //     }
                        // },
                       
                        {
                            key: 'user-management',
                            icon: < UsergroupAddOutlined />,
                            label: 'Users Management',
                            style: { display: ShowMenu(["Users", "Roles"], access) },
                            children: [
                                {
                                    key: 'users',
                                    label: 'Users',
                                    icon: <UserOutlined />,
                                    style: { display: ShowMenu(["Users"], access) },
                                    onClick: () => {
                                        navigate("/users")
                                    },
                                },
                                {
                                    key: 'roles',
                                    label: 'Roles',
                                    icon: <UserOutlined />,
                                    style: { display: ShowMenu(["Roles"], access) },
                                    onClick: () => {
                                        navigate("/roles")
                                    },
                                }
                            ]
                        },
                        // Visible to everyone: super admin sees all organizations,
                        // others their own + the ones they created
                        {
                            key: 'organizations',
                            icon: <ApartmentOutlined />,
                            label: 'Organizations',
                            onClick: () => {
                                navigate("/organizations")
                            }
                        },
                        // Facilities are managed inside an organization (Organizations > View)
                    ]}
                />
            </div>
        </Sider>
    )
}

export default Sidebar